import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IUser } from '../../../core/models/IUser';
import { UserService } from '../../../core/services/user.service';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [
    FormsModule,
    RouterLink
],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit {
  searchTerm: String = '';
  user: IUser | null = null;
  apiUrl = environment.apiUrl;
  isOpen = false;

  constructor(
    private userService: UserService, 
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isOpen = window.innerWidth <= 768; 
    this.userService.user$.subscribe(user=>{
      this.user = user;
    });
  }

  onSearch(): void {
    if (this.searchTerm && this.searchTerm.trim()) {
      this.closeMobileMenu();
      this.router.navigate(['/search'], { 
        queryParams: { q: this.searchTerm.trim() } 
      });
    } else {
      this.notificationService.warning('Veuillez entrer un terme de recherche valide.');
    }
  }

  closeMobileMenu() { 
    const navbar = document.getElementById('navbar'); 
    if (navbar?.classList.contains('show')) { 
      navbar.classList.remove('show'); 
    } 
  }
  
  toggleDropdown(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  
  logout(): void {
    this.authService.logout();
    this.router.navigate(["/"])
  }
}
